import styled from 'styled-components';

export const SContent = styled.div`
  margin-top: 8px;
  overflow: auto;
`;

export const SDocumentList = styled.div`
  padding: 16px 8px;
`;
